module.exports = __webpack_public_path__ + "img/yangzhou_s.da2ad7d.png";